import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ApplicationRoute } from '../../../constants/routes';
import BaseController from '../../BaseController';

@Controller({ component: 'panel-general', fragment: 'terms-and-cookies-list' })
class TermsAndCookiesListController extends BaseController {

  onDetailClick(nrSequencia: number, privacyNotice: boolean): void {
    if(privacyNotice) {
      this.historyService.push(ApplicationRoute.PRIVACY_NOTICE_DETAIL, { nrSequencia: nrSequencia });
    } else {
      this.historyService.push(ApplicationRoute.TERMOS_OF_USE_DETAIL, { nrSequencia : nrSequencia });
    }
  }

  @OnClick({ target: 'deck-privacy-notice' })
  onClickCardDeckPrivacyNotice(event: ClickEvent): void {
    const { nrSequencia } = event.value;

    this.onDetailClick(nrSequencia, true);
  }

  @OnClick({ target: 'deck-terms-of-use' })
  onClickCardDeckTermsOfUse(event: ClickEvent): void {
    const { nrSequencia } = event.value;

    this.onDetailClick(nrSequencia, false);
  }
}

export default TermsAndCookiesListController;